import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import fieldHints from "./fieldHints";

// Small "?" next to a form label; shows the field's hint on hover, click or tap.
// The wording lives in fieldHints.js. Renders nothing when the id has no hint.
const FieldHint = ({ id }) => {
  const [open, setOpen] = useState(false);
  const text = fieldHints[id];
  if (!text) return null;

  return (
    <Tooltip
      title={text}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      arrow
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={8000}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 320,
            whiteSpace: "pre-line",
            bgcolor: "background.paper",
            color: "text.primary",
            border: "1px solid",
            borderColor: "divider",
            boxShadow: 1,
            fontSize: "13px",
            lineHeight: 1.5,
          },
        },
        arrow: { sx: { color: "background.paper", "&::before": { border: "1px solid #ddd" } } },
      }}
    >
      <HelpOutlineIcon
        aria-label="Help"
        tabIndex={0}
        onClick={(e) => {
          e.preventDefault(); // the icon sits inside a <label>; don't focus the field
          setOpen(true);
        }}
        sx={{ fontSize: "16px", color: "#8a8a8a", ml: 0.5, verticalAlign: "text-bottom", cursor: "help" }}
      />
    </Tooltip>
  );
};

export default FieldHint;
